/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Route names defined to be used by FE and backend. these enum copied
 * into src/models on the FE to be referenced there
 *
 * CHANGING THESE ENUM VALUES WILL RESULT IN AN INVALIDATION OF USERS LOCALSTORE
 * RECENT VISITS
 *
 * naming convention: {scope}-{namespace}-{primitive}
 *
 * scope - where is this viewed
 * namespace - what namespace extension of our primitives is this
 * primitive - what primitive does this concern
 */
export enum RouteNames {
    CLUSTER_SETTINGS = 'cluster::settings',
    CLUSTER_DASHBOARDS = 'cluster::dashboards',
    CLUSTER_DELIVERABLES = 'cluster::deliverables',
    CLUSTER_MEMBER_NOTIFICATION_SETTINGS = 'cluster::member-notification-settings',
    CLUSTER_MEMBER_TASKS = 'cluster::member-tasks',
    LIBRARY_ENTITY_PERIODIC_FIELDS = 'library::entity::periodic-fields',
    LIBRARY_ENTITY_PERIODIC_FIELDS_FIELD = 'library::entity::periodic-fields::field',
    LIBRARY_ENTITY_STATIC_FIELDS = 'library::entity::static-fields',
    LIBRARY_ENTITY_STATIC_FIELDS_FIELD = 'library::entity::static-fields::field',
    LIBRARY_ENTITY_DOCUMENT_TAGS = 'library::entity::document-tags',
    LIBRARY_ENTITY_DATABASES = 'library::entity::databases',
    LIBRARY_ENTITY_DATABASES_DATABASE = 'library::entity::databases::database',
    LIBRARY_ENTITY_COVENANTS = 'library::entity::covenants',
    LIBRARY_ENTITY_COVENANTS_COVENANT = 'library::entity::covenants::covenant',
    LIBRARY_ENTITY_ROLES = 'library::entity::roles',
    LIBRARY_ENTITY_ROLES_ROLE = 'library::entity::roles::role',
    LIBRARY_ENTITY_DASHBOARDS = 'library::entity::dashboards',
    LIBRARY_ENTITY_DASHBOARDS_DASHBOARD = 'library::entity::dashboards::dashboard',
    LIBRARY_ENTITY_REPORTS = 'library::entity::reports',
    LIBRARY_ENTITY_TASK_TEMPLATES = 'library::entity::task-templates',
    LIBRARY_ENTITY_TASK_MANAGEMENT = 'library::entity::task-management',
    LIBRARY_ENTITY_ENTITIES = 'library::entity::entities',
    LIBRARY_ENTITY_WORKFLOWS = 'library::entity::workflows',
    LIBRARY_ENTITY_WORKFLOWS_WORKFLOW = 'library::entity::workflows::workflow',
    LIBRARY_ENTITY_NOTIFICATION_PREFERENCES = 'library::entity::notification-preferences',
    LIBRARY_ENTITY_NOTIFICATION_PREFERENCES_WORKFLOW = 'library::entity::notification-preferences::workflow',
    ENTITY_OVERVIEW = 'entity::overview',
    ENTITY_DELIVERABLES = 'entity::deliverables',
    ENTITY_COMMENTARY_FEED = 'entity::commentary-feed',
    ENTITY_DOCUMENTS = 'entity::documents',
    ENTITY_ASSET_ACCOUNTS = 'entity::asset-accounts',
    ENTITY_DATABASES = 'entity::databases',
    ENTITY_DATABASES_DATABASE = 'entity::databases::database',
    ENTITY_PERIODIC_FIELDS = 'entity::periodic-fields',
    ENTITY_STATIC_FIELDS = 'entity::static-fields',
    ENTITY_SETTINGS = 'entity::settings',
    ENTITY_MANAGE_ENTITY = 'entity::manage-entity',
    ENTITY_WORKFLOWS = 'entity::workflows',
    ENTITY_DATA_EXTRACTIONS = 'entity::data-extractions',
    ENTITY_COVENANTS = 'entity::covenants',
    ENTITY_COVENANTS_COVENANT = 'entity::covenants::covenant',
    ENTITY_CASH_FLOWS = 'entity::cash-flows',
    ENTITY_PERFORMANCE_METRICS = 'entity::performance-metrics',
}
